// BUNDLED: global-bundle.js
export default function() {
jQuery(function ($) {

	//register all templates with partialName defined as a partial
	//ex. <script id="myTemplate" type="text/template" partialName="myPartial">
	$('script[type="text/template"][partialName][partialName!=""]').each(function() {
		Handlebars.registerPartial(this.attributes.partialname.value, this.innerHTML);
	});

	function goToMyOrders() {
		window.location.href = '/Store/ccrz__MyAccount?cartId=' + CCRZ.pagevars.currentCartID + '&viewState=myOrders' + getCSRQueryString();
	}

	Handlebars.registerHelper('formatLeadTime', function(days){
		if(days > 19){
			if(days % 5 >= 2) {
				days = Math.ceil(days / 5);
			} else {
				days = Math.floor(days / 5);
			}
			return Math.round(days) + ' weeks';
		} else {
			return days + ' days';
		}
	});

	Handlebars.registerHelper('getviewMode', function() {
		let urlParams = new URLSearchParams(window.location.search);
		let viewMode = urlParams.get('viewState');
		return viewMode;
	});

	Handlebars.registerHelper("inc", function(value, options){
		return parseInt(value) + 1;
	});

	Handlebars.registerHelper('any', function () {
		let result = false;
		let argList=_.values(arguments);
		argList.pop();
		_.each(argList, function(val, index){
			if(val) result = true;
		});
		return result;
	});
	Handlebars.registerHelper('all', function () {
		let result = true;
		_.each(arguments, function(val, key){
			if(!val) result = false;
		});
		return result;
	});
	Handlebars.registerHelper('or', function () {
		let result;
		let argList=_.values(arguments);
		argList.pop();
		_.each(argList, function(val, index){
			if(!result && val) result = val;
		});
		return result;
	});
	Handlebars.registerHelper('colorCode', function (clr, alpha) {
		alpha = typeof alpha == "object" ? null : alpha;
		let colorCode = clr;
		if (colorCode) {
			if (colorCode.indexOf("#") != 0 && colorCode.indexOf("rgb") != 0) {
				colorCode = `#${colorCode}${alpha && colorCode.length == 6 ? alpha : ""}`;
			}
		}
		return colorCode;
	});
	Handlebars.registerHelper('checkNotCheckout', function () {
		let url = window.location.pathname;
		return !url.includes('ccrz__CheckoutNew');
	});
	Handlebars.registerHelper('IsProdStore', function () {
		return B2C_UrlUtility.isProdUrl();
	});
	Handlebars.registerHelper('envStoreUrl', function (url) {
		return B2C_UrlUtility.getEnvironmentUrl(url);
	});
	Handlebars.registerHelper("with", function (context, options) {
		return options.fn(context);
	});
	Handlebars.registerHelper('localeSwitcher', function () {
		if (CCRZ.navLocaleSwitcherView) {
			return CCRZ.navLocaleSwitcherView.model.attributes;
		} else {
			return {};
		}
	});
	Handlebars.registerHelper('checkIfEPPDiscountApplies', function () {
		return !!(sessionStorage.getItem('eppDiscountEnabled')); // != null
	});
	Handlebars.registerHelper('checkIfMessageEnabled', function () {
		return !(sessionStorage.getItem('disableMessage')); // == null
	});
	Handlebars.registerHelper('ifMapHasOneElement', function (map, options) {
		if (Object.keys(map).length == 1) {
			return options.fn(this);
		}
		return options.inverse(this);
	});
	Handlebars.registerHelper('negative', function (value) {
		return '(' + value.replace('-', '') + ')';
	});
	Handlebars.registerHelper('matches', function (left, right) {
		if (left) {
			if (left.string) {
				return left.string.trim() === right.trim();
			}
		}
		return false;
	});
	Handlebars.registerHelper('minus', function (left, right) {
		left = left ? left : 0;
		right = right ? right : 0;
		return left - right;
	});
	Handlebars.registerHelper('increment', function (x) {
		return x + 1;
	});
	Handlebars.registerHelper('isWfh', function () {
		let isWfh = false;
		if (CCRZ.headerModel && CCRZ.headerModel.get('isWfh')) {
			isWfh = true;
		}
		else if (this.isWfh){
			isWfh = true;
		}
		return isWfh;
	});
	Handlebars.registerHelper('checkNotCheckout', function () {
		let url = window.location.pathname;
		return !url.includes('ccrz__CheckoutNew');
	});

	Handlebars.registerHelper('formatCurrency', function(price, theCurrency) {
		return formatPrice(price, theCurrency);
	});

	Handlebars.registerHelper('calcItemTotal', function(value, qty) {
		return (value*qty).toFixed(2);
	});

	Handlebars.registerHelper('displayAsHtml', function(value) {
		return new Handlebars.SafeString(value);
	});

	Handlebars.registerHelper('OpenPDPEdit', function(Cartsfid, SKU) {
		let currURL = window.location.href;
		currURL = currURL+'&sku='+SKU;
		currURL = currURL+'&cartItemId='+Cartsfid;
		if (currURL.includes('viewState=')) {
			currURL= currURL.replace(/(viewState=).*?(&)/,'$1' +'EditView'+ '$2');
		} else{
			currURL += '&viewState=EditView';
		}

		currURL = currURL.replace('ccrz__Cart','ccrz__ProductDetails');
		return encodeURI(currURL);
	});

	let kitItemUrl, settingsName, settingsQty;
	Handlebars.registerHelper('setKitData', function(value) {
		kitItemUrl = value.STEXCartImageURL;
		settingsName = value.product.sfdcName;
		settingsQty = value.quantity;
	});

	Handlebars.registerHelper('displayKitData', function(type) {
		if(type=='img'){
			return encodeURI(kitItemUrl);
		}
		else if(type=='settingsName') return settingsName;
		else if(type=='settingsQty') return settingsQty;
	});

	Handlebars.registerHelper('displayKitFeature', function(value) {
		var feature='';
		if(value!=null || value==''){
			var ItemFeature = JSON.parse(value);
			feature += '<p class="cart-detail-text">';
			for(var i = 0; i < ItemFeature.length; i++) {
				feature += ItemFeature[i].ValueName;
				if (i < ItemFeature.length - 1) feature += ', ';
			}
			feature += '</p>';
		}
		return new Handlebars.SafeString(feature);
	});

	Handlebars.registerHelper('isShorterThan', function(relatedProductsList, maxLength, options){
		if (relatedProductsList.length > maxLength) {
			return options.fn(this);
		}
		return options.inverse(this);
	});

	Handlebars.registerHelper('getCartProductName', function(orderMap){
		if(Object.keys(orderMap).length>0){
			for(var key in orderMap){
				return orderMap[key][0]["productName"];
			}
		}
		return "No product name available."
	});

	Handlebars.registerHelper('removePTagFromRichText', function(rT) {
		if (rT.string != undefined) {
			const len = rT.string.length;
			if(len >= 7 &&  rT.string.substring(0,3) === '<p>' && rT.string.substring(len-4, len) === '</p>') {
				return rT.string.substring(3, len-4);
			}
		}
		return rT;
	});

	Handlebars.registerHelper('showIfReviewsEnabled', function (options) {
		if (CCRZ.pagevars.pageConfig['pd.enableproductreviews'] == "TRUE" && CCRZ.productDetailModel.attributes.showReviews) {
				return options.fn(this);
		}
		return options.inverse(this);
	});

	Handlebars.registerHelper('showIfReviewsDesktopEnabled', function (options) {
		if (CCRZ.pagevars.pageConfig['pd.enableproductreviews'] == "TRUE" && CCRZ.productDetailModel.attributes.showReviews && $(window).width() > 768) {
				return options.fn(this);
		}
		return options.inverse(this);
	});

	Handlebars.registerHelper('showIfReviewsMobileEnabled', function (options) {
		if (CCRZ.pagevars.pageConfig['pd.enableproductreviews'] == "TRUE" && CCRZ.productDetailModel.attributes.showReviews && $(window).width() <= 768) {
				return options.fn(this);
		}
		return options.inverse(this);
    });


    Handlebars.registerHelper('showIfMobileEnabled', function (options) {
		if($(window).width() <= 768){
				return options.fn(this);
		}
		return options.inverse(this);
	});

	Handlebars.registerHelper('showIfDesktopEnabled', function (options) {
		if($(window).width() > 768){
				return options.fn(this);
		}
		return options.inverse(this);
	});

	Handlebars.registerHelper('displayImageLazy',function(obj,styleClass,options){
		if(options&&options.hash['src']){
			var imgSrc=_.escape(options.hash['src']);
		} else{
			var imgSrc=CCRZ.processImageURL(obj,styleClass,options);
		}

		var alt="";

		if(options&&options.hash['alt']) alt=_.escape(options.hash['alt']);

		var dataId="";

		if(options&&options.hash['dataId']) dataId=_.escape(options.hash['dataId']);

		if(imgSrc.length>0) return new Handlebars.SafeString("<img loading='lazy' class='"+styleClass+"' src='"+imgSrc+"' alt='"+alt+"' data-id='"+dataId+"' />");
		else return new Handlebars.SafeString("<img loading='lazy' class='"+styleClass+" "+CCRZ.pagevars.userLocale+" noImg' alt='"+alt+"' data-id='"+dataId+"' />");
	});

	Handlebars.registerHelper('pageLabelMapSafe', function(labelName) {
		let params = Array.prototype.slice.call(arguments,1)
		let label = Handlebars.helpers.removePTagFromRichText(
			CCRZ.processPageLabelMap(labelName, params)
		);
		return (typeof label == 'string') ? label : label?.string;
	});

	Handlebars.registerHelper('equals', function(arg1, arg2) {
		return arg1 == arg2;
	});

	Handlebars.registerHelper('concat', function(...args) {
		let result = '';
		args.forEach((element, index) => {
			if (index !== args.length - 1)
				result += element;
		});
		return result;
	});

	Handlebars.helpers._each_upto = Handlebars.helpers.each_upto;
	Handlebars.registerHelper('each_upto', function(arr,max,opt) {
		arr = arr?.filter((el) => el != null && el != undefined);
		return Handlebars.helpers._each_upto(arr,max,opt);
	});

	Handlebars.registerHelper('toLowerCase', function(str) {
		return str.toLowerCase();
	});

	Handlebars.registerHelper('isArray', function(arg) {
		return Array.isArray(arg);
	});

	Handlebars.registerHelper('searchString', function() {
		return CCRZ.productListPageView?.getCurrentSearchString();
	});

	Handlebars.registerHelper('isCategoryPage', function() {
		let catId = CCRZ.searchParams.categoryId;
		return catId !== '' && catId !== undefined;
	});

	Handlebars.registerHelper('isNoResultsPage', function() {
		return CCRZ.productListPageView.isNoResultsPage();
	});

	Handlebars.registerHelper('hideElementIf', function(condition, options) {
		if (condition) {
			return new Handlebars.SafeString('<div class="hidden">' + options.fn(this) + '</div>');
		}

		return options.fn(this);
	});

	Handlebars.registerHelper("selectGeo", function(name, entries, value, styleClass, prefix, placeholder, idSuffix) {
		var fullStyles = styleClass + " " + prefix + "Field " + prefix + name;
		var fullName = '';
		var selectId = `${name}_${(idSuffix || prefix)}`;
		if (prefix && (prefix.indexOf('.', prefix.length - 1) !== -1))
			fullName = prefix + name;
		else
			fullName = prefix + 'Address.' + name;
		if (entries && entries.length > 0) {
			var buffer = "<select id ='" + selectId + "' name='" + fullName + "Code' class='" + fullStyles + "'>";
			for (var i = 0, j = entries.length; i < j; i++) {
				buffer += "<option value='" + entries[i].value + "'";
				if (value && value == entries[i].value)
					buffer += " selected";
				buffer += ">" + entries[i].label + "</option>";
			}
			buffer += "</select>";
			return buffer;
		} else {
			var buffer2 = "<input id ='" + fullName + "' name='" + fullName + "' class='" + fullStyles + "' value='" + value + (placeholder ? "' placeholder='" + placeholder : "") + "' maxLength='255'>";
			return buffer2;
		}
	});

	Handlebars.registerHelper("loadVideo", function (name, controls) {
		let videoValues = {};
		if (CCRZ.pagevars.videoControls) {
			videoValues = CCRZ.pagevars.videoControls;
		}
		videoValues[name] = controls;
		CCRZ.pagevars.videoControls = videoValues;
	});

	Handlebars.registerHelper("getLocaleCountryCode", function() {
		return CCRZ.pagevars.userLocale.split('_')[1];
	});

	Handlebars.registerHelper("isSafari", function() {
		return navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
	});

	Handlebars.registerHelper("hexToFilter", function (hex) {
		return B2C_ColorFilterUtility.hexToFilter(hex);
	});

	Handlebars.registerHelper("padStr", function (str, length, padChar) {
		return String(str).padStart(length, padChar);
	});

	Handlebars.registerHelper("renderRichText", function(rt) {
		return new Handlebars.SafeString(_.unescape(Handlebars.helpers.removePTagFromRichText(rt)));
	});

	Handlebars.registerHelper("richTextOrFallback", function(rt, fallback) {
		return rt ? Handlebars.helpers.renderRichText(rt) : fallback;
	});

	Handlebars.registerHelper("getHeaderModel", function(rt, fallback) {
		return CCRZ.headerModel?.attributes;
	});

	Handlebars.registerHelper("add", function(...args) {
		return args.reduce((acc, curr) => acc = acc ? acc + curr : curr);
	});

	Handlebars.registerHelper("replaceLineBreaks", function(str) {
		if (!str) {
			return new Handlebars.SafeString("");
		}
		return new Handlebars.SafeString(_.unescape(str.replaceAll(/\r\n|\r|\n/g, "<br>")));
	});

	Handlebars.registerHelper('getMenuGroups', function () {
		return CCRZ.menuModel.attributes?.menuGroups;
	});

	Handlebars.registerHelper('numKeys', function (obj) {
		return (obj != null && typeof obj === 'object') ? Object.keys(obj).length : 0;
	});

	Handlebars.registerHelper('sub', function(a, b) {
		return a - b;
	});

	Handlebars.registerHelper('priceDisplayAlgolia', (prod) => {
		let isRangePricing = prod.price.sale instanceof Array,
			price = isRangePricing ? prod.price.sale[0] : prod.price.sale;

		return Handlebars.helpers.productPriceDisplay2(price, prod.price.discountAmount);
	});

	Handlebars.registerHelper('fallback', function(...args) {
		return args.find(element => element != null);
	});
	
	/**
	 * WCAG contrast helper:
	 * - Converts HEX → relative luminance (WCAG 2.1 formula)
	 * - Computes contrast ratio: (L1 + 0.05) / (L2 + 0.05)
	 * - Uses AA threshold ≥ 4.5 for normal text
	 *
	 * Logic:
	 * - If user color meets ≥ 4.5 → use it
	 * - Otherwise fallback to best contrast between:
	 *     ONYX (#272725) or WHITE (#FFFFFF)
	 *
	 * References:
	 * - https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color#:~:text=Based%20on%20Mark,Copy
	 * - https://www.w3.org/TR/WCAG21/#dfn-relative-luminance
	 * - https://www.w3.org/TR/WCAG21/#contrast-minimum
	 */
	Handlebars.registerHelper('getTextColor', function(bgHex, userHex) {
		const ONYX = '#272725';
		const WHITE = '#FFFFFF';
		const WCAG_AA_RATIO = 4.5;

		function normalizeHex(hex) {
			if (!hex) return null;

			hex = hex.trim();

			if (!hex.startsWith('#') && /^[0-9a-fA-F]{6}$/.test(hex)) {
				hex = '#' + hex;
			}

			if (!/^#[0-9a-fA-F]{6}$/.test(hex)) return null;

			return hex.toUpperCase();
		}

		function hexToRgb(hex) {
			const clean = hex.replace('#', '');
			return clean.match(/.{2}/g).map(v => parseInt(v, 16) / 255);
		}

		function relativeLuminance(hex) {
			const [r, g, b] = hexToRgb(hex).map(c =>
				c <= 0.03928
					? c / 12.92
					: Math.pow((c + 0.055) / 1.055, 2.4)
			);

			return 0.2126 * r + 0.7152 * g + 0.0722 * b;
		}

		function contrastRatio(a, b) {
			const l1 = relativeLuminance(a);
			const l2 = relativeLuminance(b);
			return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
		}

		const background = normalizeHex(bgHex);
		const userColor = normalizeHex(userHex);

		if (!background) return ONYX;

		const onyxRatio = contrastRatio(background, ONYX);
		const whiteRatio = contrastRatio(background, WHITE);

		const fallback =
			whiteRatio >= WCAG_AA_RATIO && whiteRatio >= onyxRatio
				? WHITE
				: ONYX;

		if (userColor) {
			const ratio = contrastRatio(background, userColor);

			if (ratio >= WCAG_AA_RATIO) {
				return userColor;
			}
		}

		return fallback;
	});
});
}
